import React, {useEffect, useRef, useState} from 'react';
import {
	Container,
	Arrow,
	DatesWrapper,
	DateCard,
	Day,
	DateText,
	Hour, DatesViewport,
} from './EventDatesCarrousel.styles';

import {EventDates} from "../../../store/ducks/event/types";
import {formatDay, formatDayMonth, formatHour} from "../../../utils/dateUtils";

interface Props {
	dates: EventDates[];
	selectedId: number | null;
	onChange: (id: number) => void;
}

const EventDatesCarousel: React.FC<Props> = ({
												 dates,
												 selectedId,
												 onChange,
											 }) => {
	const viewportRef = useRef<HTMLDivElement>(null);
	const [showArrows, setShowArrows] = useState(false);

	useEffect(() => {
		const el = viewportRef.current;
		if (!el) return;

		setShowArrows(el.scrollWidth > el.clientWidth);
	}, [dates]);

	const scroll = (direction: 'left' | 'right') => {
		viewportRef.current?.scrollBy({
			left: direction === 'left' ? -240 : 240,
			behavior: 'smooth',
		});
	};

	return (
		<Container>
			{showArrows && <Arrow onClick={() => scroll('left')}>‹</Arrow>}

			<DatesViewport ref={viewportRef}>
				<DatesWrapper>
					{dates.map((date, index) => {
						const start = new Date(date.startDate);
						const isSingle = dates.length === 1;
						const isFirst = index === 0;
						const isLast = index === dates.length - 1;

						return (
							<DateCard
								key={date.id}
								active={date.id === selectedId}
								isSingle={isSingle}
								isFirst={isFirst}
								isLast={isLast}
								onClick={() => onChange(date.id)}
							>
								<Day>{formatDay(start)}</Day>
								<DateText>{formatDayMonth(start)}</DateText>
								<Hour>{formatHour(start)}</Hour>
							</DateCard>
						);
					})}
				</DatesWrapper>
			</DatesViewport>

			{showArrows && <Arrow onClick={() => scroll('right')}>›</Arrow>}
		</Container>
	);
};

export default EventDatesCarousel;
